import type { TableWidget } from "@/elements/table/table";
import type { Group } from "@/group";
import { MAX_NUMBER_OF_WIDGETS_FOR_AI_PROCESS } from "../constants/aiConstants";

function getTableCeilsQuantity(table: TableWidget) {
    let result = 0;
    for (const row of table.rows) {
        result += row.cells.length;
    }

    return result;
}

export function checkIsWidgetsQuantityExceeded(groups: Group[]) {
    if (groups.length > MAX_NUMBER_OF_WIDGETS_FOR_AI_PROCESS) {
        return true;
    }

    let widgetsQuantity = 0;

    for (const group of groups) {
        if (group.isItemWrapper()) {
            if (group.onlyChild()?.constructorName === "table") {
                widgetsQuantity += getTableCeilsQuantity(group.onlyChild() as TableWidget);

                continue;
            }
            widgetsQuantity++;

            continue;
        }

        group.children.forEach((child) => {
            if ("rows" in child) {
                widgetsQuantity += getTableCeilsQuantity(child as TableWidget);

                return;
            }

            widgetsQuantity++;
        });
    }

    if (widgetsQuantity > MAX_NUMBER_OF_WIDGETS_FOR_AI_PROCESS) {
        return true;
    }

    return false;
}
